<template>
    <div >
        <div class="box-title flex-between">
            <div class="box-title-text box-title-bg02">
                <p class="">抵押等级统计（笔）</p>
            </div>
            <div class="box-title-right">
            </div>
        </div>
        <div id="echart03" class="chart03" :style="{height: '360px'}"></div>
    </div>
</template>

<script>

    import xhr from "../../../utils/xhr";

    export default {
        name: 'MonitorEchartsThree',
        data() {
            return {
                nowDate: "",
                financingByPledgeGradeList: []
            }
        },
        computed: {

        },
        mounted() {
            this.getFinancingByPledgeGradeList()
        },
        methods:{
            echart03(){
                let myChart = this.$echarts.init(document.getElementById('echart03'))
                myChart.setOption({
                    // color: ['#3f8cf8','#11baa8','#e8d745','#e88c45'],
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)',
                        textStyle:{
                            fontSize:24,
                            color:'#96dcff'
                        }
                    },
                    legend: {
                        orient: 'vertical',
                        right: '29%',
                        top: '22%',
                        data: this.financingByPledgeGradeList.map(item=>item.fi__grade),
                        textStyle:{
                            fontSize:24,
                            color:'#96dcff'
                        },
                    },
                    series: [
                        {
                            name: '抵押等级',
                            type: 'pie',
                            radius: '55%',
                            center: ['35%', '45%'],
                            data: this.financingByPledgeGradeList.map(item=>({
                                name: item.fi__grade,
                                value: item.fi__counts||0
                            })),
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            },
                            itemStyle:{
                                normal:{
                                    label:{
                                        textStyle:{
                                            fontSize:24,
                                            color:'#96dcff'
                                        }
                                    },
                                    labelLine:{
                                        lineStyle:{
                                            color:'#96dcff'
                                        }
                                    }
                                }

                            }
                        }
                    ]

                });
            },
            getFinancingByPledgeGradeList: function () {
                xhr.getFinancingByPledgeGradeList(0, ({data}) => {
                    if (data.status === 'success') {
                        console.log('data', data.data)
                        this.financingByPledgeGradeList = (data.data || []).filter(item=>item.fi__grade)

                        this.echart03();
                    }
                })
            }
        },
        components: {

        },
        props: {

        },
        beforeDestroy() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorEchartsThree.vue